export default __webpack_public_path__ + "static/media/Icon_SingleSelectImageChoice.fea01662.svg";